module.exports = __webpack_public_path__ + "assets/outdoor.2c25c3b7.svg";